<template>
    <project-template>

        <project-image
        size="100"
        path="/img/p/brush8/wireframeheader.jpg"
        alt="Brush8 Wireframes Image Header"/>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>The Backstory</h1>
          <p>The client hired Milk* to develop the brand, logo, packaging, and website design for their subscription electric toothbrush. My specific role on this project was to execute the design of the website, from information architecture to high fidelity visual design and every step in between.</p>
        </project-text>

        <project-video
        size="75"
        videoID="350336258"
        :gif="true"/>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Prototypes, Wireframes, Flowcharts, and more</h1>
          <p>I began my contribution to this project by studying what made similar subscription services work. What did these successful services emphasize on their landing page? What did they do to lead customers in the right direction and make the shopping process easy for them?<br><br>After considering my findings and developing a series of sitemap flowcharts and user journey exploration, I moved onto the wireframing stage. By creating over 50 low-fidelity wireframe screens and integrating them into a working clickable prototype, the client was able to have a clear picture about how the site would function and the proposed functionalities that would be available to the user.</p>
        </project-text>

        <project-carousel
        size="75"
        :color="$store.state.activeProject.color"
        :autoplay="false">
          <slide><img v-lazy="'/img/p/brush8/prototypelinks.jpg'" alt="Prototype Links"></slide>
          <slide><img v-lazy="'/img/p/brush8/wireframes.jpg'" alt="Wireframe Overview"></slide>
          <slide><img v-lazy="'/img/p/brush8/flowchart.jpg'" alt="Sitemap"></slide>
        </project-carousel>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Setting the Ground Rules</h1>
          <p>After a couple rounds of back and forth, adjusting the prototype as necessary to meet new goals and limitations, we arrived to the visual design stage. I envisioned the design direction for the site and created an accompanying style guide, so that the website would maintain visual consistency across every page. This document included guidelines for typography, color, buttons, shadows, spacing, and more.</p>
        </project-text>

        <project-image
        size="75"
        path="/img/p/brush8/style.jpg"
        alt="Style Guide and Components"/>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Adding Some Color</h1>
          <p>Finally, I was able to flesh out a couple different UI design options for the website that adhered to the style guide and stayed true to the approved wireframes. The project is currently in development, and is anticipated to launch late 2019.</p>
        </project-text>

        <project-image
        size="75"
        path="/img/p/brush8/renders.jpg"
        alt="Brush8 Site Renders"/>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectImage from '../../components/project/ProjectImage.vue'
import ProjectText from '../../components/project/ProjectText.vue'
import ProjectCarousel from '../../components/project/ProjectCarousel.vue'
import ProjectVideo from '../../components/project/ProjectVideo.vue'
import { Slide } from 'vue-carousel'

export default {
  components: { ProjectTemplate, ProjectText, ProjectImage, ProjectVideo, ProjectCarousel, Slide }
}
</script>

<style lang="scss" scoped>

</style>
